/* Datei: src/pages/BlogAdmin/BlogAdmin.js */
import React, { useState } from 'react';
import KeywordManagement from './KeywordManagement';
import BlogGenerator from './BlogGenerator';
import BlogManagement from './BlogManagement';
import './BlogAdmin.css';

const BlogAdmin = () => {
  const [activeTab, setActiveTab] = useState('keywords'); // 'keywords', 'generator', 'management'

  return (
    <div className="blog-admin">
      <header className="blog-admin-header">
        <h1>Blogverwaltung</h1>
        <nav>
          <button className={activeTab === 'keywords' ? 'active' : ''} onClick={() => setActiveTab('keywords')}>
            Keywords setzen
          </button>
          <button className={activeTab === 'generator' ? 'active' : ''} onClick={() => setActiveTab('generator')}>
            Blogs generieren
          </button>
          <button className={activeTab === 'management' ? 'active' : ''} onClick={() => setActiveTab('management')}>
            Blog verwalten
          </button>
        </nav>
      </header>
      <main className="blog-admin-content">
        {activeTab === 'keywords' && <KeywordManagement />}
        {activeTab === 'generator' && <BlogGenerator />}
        {activeTab === 'management' && <BlogManagement />}
      </main>
    </div>
  );
};

export default BlogAdmin;
